import { Alert, Box, Button, TextField } from '@atgfr8/atg-ui-tailwind';
import { BasicModal } from '@components';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { Component, createSignal, Show } from 'solid-js';

type PropsT = {
  id: string;
  hasError?: boolean;
  onSave: (name: string, cb: () => void) => Promise<void>;
  onCloseModal: (label: string) => void;
};

export const SaveModal: Component<PropsT> = (props: PropsT) => {
  const [name, setName] = createSignal('');
  const [error, setError] = createSignal(false);
  const [isSaving, setIsSaving] = createSignal(false);

  return (
    <BasicModal
      title="Name Your Filter"
      id={props.id}
      onClose={() => {
        props.onCloseModal(props.id);
        setName('');
      }}
      footer={false}
      showClose={false}
      width="800px"
      maxWidth="800px"
    >
      <Box class="flex mb-3 [&>.text-field-root]:w-full">
        {props.hasError !== undefined && props.hasError ? (
          <Alert color="error" text="There was an error saving the filter" />
        ) : undefined}
        <TextField
          dataTestId={'filter-name-textInput'}
          label="Filter Name"
          placeholder="Filter Name"
          name="filterName"
          class="w-full"
          onChange={(val: string) => {
            setName(val);
            setError(false);
          }}
          maxLength={80}
          error={error() ? 'Filter Name is required' : undefined}
        />
      </Box>
      <Box class="flex justify-end">
        <Button
          disabled={isSaving()}
          dataTestId={formatDataTestId('submit-filter', 'button')}
          onClick={async () => {
            if (!Boolean(name())) {
              setError(true);
              return;
            }
            setIsSaving(true);
            await props.onSave(name(), () => {
              setIsSaving(false);
              setName('');
            });
          }}
          startIcon={
            <Show when={isSaving()}>
              <span class="loading loading-spinner loading-sm" />
            </Show>
          }
          class="mr-2!"
        >
          Submit
        </Button>
        <Button
          variant="outlined"
          dataTestId={formatDataTestId('cancel-filter', 'button')}
          onClick={() => {
            props.onCloseModal(props.id);
            setName('');
          }}
        >
          Cancel
        </Button>
      </Box>
    </BasicModal>
  );
};
